import { render, staticRenderFns } from "./TableButtonFixedAssetsUnassign.vue?vue&type=template&id=37b2686a&"
import script from "./TableButtonFixedAssetsUnassign.vue?vue&type=script&lang=js&"
export * from "./TableButtonFixedAssetsUnassign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports